export function diagramDrawer(ctx) {
  return function () {
    ctx = this._chart.ctx;
    const vm = this._view;
    const borderWidth = vm.borderWidth;

    let cornerRadius = this._chart.config.options.cornerRadius;
    if (cornerRadius < 0) {
      cornerRadius = 0;
    }

    if (typeof cornerRadius == 'undefined') {
      cornerRadius = 0;
    }

    // bar
    const left = vm.x - vm.width / 8 + 2;
    const right = vm.x;
    const top = vm.y;
    const bottom = vm.base;
    const borderSkipped = vm.borderSkipped || 'bottom';

    ctx.beginPath();
    ctx.fillStyle = vm.backgroundColor;
    ctx.strokeStyle = vm.borderColor;
    ctx.lineWidth = borderWidth;

    // Corner points, from bottom-left to bottom-right clockwise
    // | 1 2 |
    // | 0 3 |
    const corners = [
      [left, bottom],
      [left, top],
      [right, top],
      [right, bottom],
    ];

    // Find first (starting) corner with fallback to 'bottom'
    const borders = ['bottom', 'left', 'top', 'right'];
    let startCorner = borders.indexOf(borderSkipped, 0);
    if (startCorner === -1) {
      startCorner = 0;
    }

    function cornerAt(index) {
      return corners[(startCorner + index) % 4];
    }

    // Draw rectangle from 'startCorner'
    const corner = cornerAt(0);
    if (corner) {
      ctx.moveTo(corner[0], corner[1]);
    }

    for (let i = 1; i < 4; i++) {
      const width = 12;
      let height =
        (corners[0] ? corners[0][1] : 0) - (corners[1] ? corners[1][1] : 0);
      const x = corners[1] ? corners[1][0] : 0;
      const y = corners[1] ? corners[1][1] : 0;

      let radius = cornerRadius;
      // Fix radius being too large
      if (radius > Math.abs(height) / 2) {
        radius = Math.floor(Math.abs(height) / 2);
      }
      if (radius > Math.abs(width) / 2) {
        radius = Math.floor(Math.abs(width) / 2);
      }

      if (height < 0) {
        // Negative values in a standard bar chart
        height = height + 2.5;
        const x_tl = x;
        const x_tr = x + width;
        const y_tl = y + height;
        const y_tr = y + height;

        const x_bl = x;
        const x_br = x + width;
        const y_bl = y;
        const y_br = y;

        // Draw
        ctx.moveTo(x_bl + radius, y_bl);
        ctx.lineTo(x_br - radius, y_br);
        ctx.quadraticCurveTo(x_br, y_br, x_br, y_br - radius);
        ctx.lineTo(x_tr, y_tr + radius);
        ctx.quadraticCurveTo(x_tr, y_tr, x_tr - radius, y_tr);
        ctx.lineTo(x_tl + radius, y_tl);
        ctx.quadraticCurveTo(x_tl, y_tl, x_tl, y_tl + radius);
        ctx.lineTo(x_bl, y_bl - radius);
        ctx.quadraticCurveTo(x_bl, y_bl, x_bl + radius, y_bl);
      } else {
        height = height - 2.5;
        //Positive Value
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(
          x + width,
          y + height,
          x + width - radius,
          y + height
        );
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
      }
    }

    ctx.fill();
    if (borderWidth) {
      ctx.stroke();
    }
  };
}
